import { ApiService } from "core/services";

class TenantApi extends ApiService {
  constructor() {
    super("tenant");
  }

  getAll(payload = null) {
    return this.get("", payload);
  }

  createTenant(payload) {
    return this.post("", payload);
  }

  updateTenant(payload) {
    return this.put("", payload);
  }

  // Get overview management
  getSettingOverviewMng() {
    return this.get("systems");
  }

  // Set overview management
  setSettingOverviewMng(payload) {
    return this.put("systems", payload);
  }

  getTenantInfo(payload) {
    return this.get(`${payload.tenantId}`);
  }

  getAllUsers(payload) {
    return this.get(`${payload.tenantId}/users`, payload);
  }

  getUser(payload) {
    return this.get(`${payload.tenantId}/users/${payload.userId}/`);
  }

  createUser(payload) {
    return this.post(`${payload.tenantId}/users?force=` + payload.forceCreate, payload);
  }

  updateUser(payload) {
    return this.put(`${payload.tenantId}/users/${payload.userId}/`, payload);
  }

  deleteUser(payload) {
    return this.delete(`${payload.tenantId}/users/${payload.userId}/`);
  }

  unlockUser(payload) {
    return this.put(`${payload.tenantId}/users/${payload.userId}/unlock`);
  }

  getTenantTeams(payload = null) {
    return this.get(`${payload.tenantId}/teams`, payload);
  }

  getTenantTeamsAll(payload) {
    return this.get(`${payload.tenantId}/teams/all`);
  }

  getTenantTeamById(payload = null) {
    return this.get(`${payload.tenantId}/teams/${payload.id}`, payload.pageInfo);
  }

  addTenantTeam(payload) {
    return this.post(`${payload.tenantId}/teams`, payload);
  }

  updateTenantTeamName(payload) {
    return this.put(`${payload.tenantId}/teams/${payload.id}`, { name: payload.name });
  }

  getTenantUsersNotInTeam(payload = null) {
    return this.get(`${payload.tenantId}/teams/users-not-in-team/${payload.id}`, payload.pageInfo);
  }

  addTenantUsersForTeam(payload) {
    return this.post(`${payload.tenantId}/teams/add-user/${payload.id}`, { sequences: payload.sequences });
  }

  deleteTenantUserForTeam(payload) {
    return this.delete(`${payload.tenantId}/teams/user/${payload.id}?sequence=${payload.sequence}`);
  }

  deleteTenantTeam(payload) {
    return this.delete(`${payload.tenantId}/teams/${payload.id}`);
  }

  // チームAPI-Token一覧取得
  getTenantTeamTokens(payload) {
    return this.get(`${payload.tenantId}/apitoken/teams/${payload.teamsId}`);
  }

  // チームAPI-Token生成
  generateTenantTeamToken(payload) {
    return this.post(`${payload.tenantId}/apitoken/teams/${payload.teamsId}`);
  }

  // チームAPI-Token生成
  updateTenantTeamToken(payload) {
    return this.put(`${payload.tenantId}/apitoken/teams/${payload.id}`, payload);
  }

  // チームAPI-Token生成
  deleteTenantTeamToken(payload) {
    return this.delete(`${payload.tenantId}/apitoken/teams/${payload.id}`);
  }
}

export default TenantApi;
